import {
  ApiRoute,
  CreateOrgReview,
  OrgPublicDetail,
  OrgPublicDetailSchema,
  OrgReview,
  OrgReviewDetail,
  OrgReviewDetailSchema,
  OrgReviewSchema,
  getApiRoute
} from "@garther/interfaces";
import { z } from "zod";

import { API_BASE_URL } from "../configs";
import { BaseApiClient } from "./base-client";

class OrgApiClient extends BaseApiClient {
  constructor() {
    super({
      baseURL: API_BASE_URL,
      baseEndpoint: getApiRoute(ApiRoute.ORG),
      requireAuth: true
    });
  }

  async getOne(orgId: string): Promise<OrgPublicDetail | null> {
    try {
      return await this.get(orgId, OrgPublicDetailSchema, { requireAuth: false });
    } catch (error) {
      return null;
    }
  }

  async getReviews(orgId: string): Promise<OrgReviewDetail[]> {
    return await this.get(`${orgId}/reviews`, z.array(OrgReviewDetailSchema), {
      requireAuth: false
    });
  }

  async createReview(orgId: string, data: CreateOrgReview): Promise<OrgReview> {
    return await this.post(`${orgId}/reviews`, OrgReviewSchema, data, { requireAuth: true });
  }
}

export const orgApiClient = new OrgApiClient();
